import { render, staticRenderFns } from "./points_gift.vue?vue&type=template&id=1d25bb9b&scoped=true"
import script from "./points_gift.vue?vue&type=script&lang=js"
export * from "./points_gift.vue?vue&type=script&lang=js"
import style0 from "./points_gift.vue?vue&type=style&index=0&id=1d25bb9b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d25bb9b",
  null
  
)

export default component.exports